import { systemEngineEnvironment } from "services/environment/systemEngine";

import {
  EngineFamily,
  WorkspaceEngine,
  WorkspaceEngineType,
} from "./engine.types";

export type EditEngineInput = {
  engineName: string;
  type: WorkspaceEngineType;
  nodes: number;
  autoStop: string;
  autoStart: boolean;
  minClusters: number;
  maxClusters: number;
  engineOwner: string;
  family?: EngineFamily;
};

export const editWorkspaceEngine = async ({
  engine,
  initialEngine,
}: {
  engine: EditEngineInput;
  initialEngine: WorkspaceEngine;
}) => {
  if (engine.engineName !== initialEngine.engineName) {
    await systemEngineEnvironment.execute(
      `ALTER ENGINE "${initialEngine.engineName}" RENAME TO "${engine.engineName}";`
    );
  }

  if (engine.autoStop !== initialEngine.autoStop) {
    const autoStopPart = systemEngineEnvironment.formatter.formatQuery(
      `ALTER ENGINE "${engine.engineName}" SET
AUTO_STOP = ?
`,
      [Number(engine.autoStop)]
    );
    await systemEngineEnvironment.execute(autoStopPart);
  }

  if (engine.autoStart !== initialEngine.autoStart) {
    const autoStartPart = systemEngineEnvironment.formatter.formatQuery(
      `ALTER ENGINE "${engine.engineName}" SET
AUTO_START = ?
`,
      [engine.autoStart]
    );
    await systemEngineEnvironment.execute(autoStartPart);
  }

  if (
    engine.minClusters !== initialEngine.minClusters ||
    engine.maxClusters !== initialEngine.maxClusters
  ) {
    const clustersPart = systemEngineEnvironment.formatter.formatQuery(
      `ALTER ENGINE "${engine.engineName}" SET
MIN_CLUSTERS = ?
MAX_CLUSTERS = ?
`,
      [Number(engine.minClusters), Number(engine.maxClusters)]
    );
    await systemEngineEnvironment.execute(clustersPart);
  }

  if (
    engine.type !== initialEngine.type ||
    engine.nodes !== initialEngine.nodes
  ) {
    const engineSql = systemEngineEnvironment.formatter.formatQuery(
      `ALTER ENGINE "${engine.engineName}" SET
TYPE = "${engine.type}"
NODES = ?
`,
      [Number(engine.nodes)]
    );
    await systemEngineEnvironment.execute(engineSql);
  }

  if (engine.family !== initialEngine.family && engine.family) {
    const engineSql = systemEngineEnvironment.formatter.formatQuery(
      `ALTER ENGINE "${engine.engineName}" SET FAMILY = "${engine.family}"`
    );
    await systemEngineEnvironment.execute(engineSql);
  }
};
